
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface BasicInfoSectionProps {
  formData: {
    full_name: string;
    professional_title: string;
  };
  onInputChange: (field: string, value: string) => void;
}

export default function BasicInfoSection({ formData, onInputChange }: BasicInfoSectionProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor="full_name">Full Name</Label>
        <Input
          id="full_name"
          value={formData.full_name}
          onChange={(e) => onInputChange('full_name', e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor="professional_title">Professional Title</Label>
        <Input
          id="professional_title"
          value={formData.professional_title}
          onChange={(e) => onInputChange('professional_title', e.target.value)}
        />
      </div>
    </div>
  );
}
